import { render, staticRenderFns } from "./manageUntreatedOrder.vue?vue&type=template&id=c5ac468e&"
import script from "./manageUntreatedOrder.vue?vue&type=script&lang=js&"
export * from "./manageUntreatedOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports